<script lang="ts">
	import { getOptimizedCmsImageUrl } from '@app/utils/cms';
	import AdaptiveImage from '$lib/components/AdaptiveImage.svelte';
	import { storyblokEditable } from '@storyblok/svelte';
	import type { ImageProps } from '@app/components/cms/types';

	export let props: {
		title: string;
		image: ImageProps;
		classNames: string;
	};

	$: ({ title, image, classNames } = props);

	const getAdaptiveImagesData = (filename: string, alt: string): Record<string, any> => {
		return {
			sources: [
				{
					srcset: `${getOptimizedCmsImageUrl(filename, '800x1732')} 800w, ${getOptimizedCmsImageUrl(
						filename,
						'1920x418'
					)} 1920w`
				}
			],
			img: getOptimizedCmsImageUrl(filename, '1920x418'),
			alt: alt ? alt : 'wiseed'
		};
	};
</script>

<div
	use:storyblokEditable={props}
	class="relative h-[80vh] md:h-[70vh] lg:h-[55vh] flex items-center justify-center {classNames}"
>
	{#if image?.filename}
		<div class="absolute inset-0">
			<AdaptiveImage
				src={getAdaptiveImagesData(image.filename, image.alt)}
				classNames="object-cover w-full h-full"
				isLazyLoaded={false}
			/>
		</div>
	{/if}
	<div class="relative {image?.filename ? 'text-white' : ''}">
		{#if title?.length}
			<h1 class="text-center">{@html title}</h1>
		{/if}
	</div>
</div>
